export const CURRENT_YEAR = process.env.REACT_APP_CURRENT_YEAR || "2026";
export const DATE = process.env.REACT_APP_DATE || "2. 8. - 16. 8.";
export const MAIN_PRICE = process.env.REACT_APP_MAIN_PRICE || "5.200";
export const SHORT_PRICE = process.env.REACT_APP_SHORT_PRICE || "2.600";
export const IS_REGISTRATION_CLOSED = process.env.REACT_APP_REGISTRATION_CLOSED === 'true';
export const IS_PRESCHOOL_CLOSED = process.env.REACT_APP_PRESCHOOL_CLOSED === 'true';